export default __webpack_public_path__ + "static/media/tree2.87165f16.png";